import {IApiRosterHistoryEvent} from "ng-league";
import {groupBy, forEach, find, sortBy} from "lodash";

export interface HumanReadableRosterEventLog {
    userId: number;
    leave: string;
    join: string;
}

export class RosterHistoryTransformer {

    /**
     * @param events
     * @returns {HumanReadableRosterEventLog[]}
     */
    public getHistoryLog(events: IApiRosterHistoryEvent[]): HumanReadableRosterEventLog[] {
        let contestantLogs = groupBy(events, (event: IApiRosterHistoryEvent) => {
            return event.userId;
        });

        let readableLogs: HumanReadableRosterEventLog[] = [];

        forEach(contestantLogs, (contestantEvents: IApiRosterHistoryEvent[], contestantId: string) => {
            forEach(contestantEvents, (event: IApiRosterHistoryEvent) => {
                let log = find(readableLogs, (readableLog: HumanReadableRosterEventLog) => {
                    return  readableLog.userId === parseInt(contestantId, 10)
                        && (event.action === "join" ? !readableLog.join : !readableLog.leave);
                });

                if (!log) {
                    log = {
                        userId: parseInt(contestantId, 10),
                        leave: null,
                        join: null,
                    };

                    readableLogs.push(log);
                }

                (event.action === "join") ? log.join = event.date : log.leave = event.date;
            });
        });

        // sort by newest
        return sortBy(readableLogs, (log: HumanReadableRosterEventLog) => {
            return -(new Date(log.join)).getTime();
        });
    }
}